import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, useRouter } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";
import { ErrorState, NotFoundView } from "../components/states.tsx";

export interface RouterContext {
  queryClient: QueryClient;
}

/**
 * Every animation in the app follows the person's "reduce motion" setting: movement stops, fades stay.
 */
function Root() {
  return (
    <MotionConfig reducedMotion="user">
      <Outlet />
    </MotionConfig>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: RootError,
});

function NotFound() {
  return <NotFoundView />;
}

function RootError({ error }: { error: unknown }) {
  const router = useRouter();
  return <ErrorState error={error} onRetry={() => void router.invalidate()} />;
}
